export default __webpack_public_path__ + "assets/images/52696f9a35e3b4250cf68a3d88ca8fdc.svg";